import {
  Button,
  IconButton
} from "@mui/material";
import { format } from 'date-fns';
import React, { useMemo } from "react";
// import { Chart } from "react-chartjs-2";
// import { tableFromIPC } from '@uwdata/flechette';

// import { Select } from "./input";
// import { BarChart } from '@mui/x-charts/BarChart';
import DownloadIcon from '@mui/icons-material/Download';
import { downloadDataAsCSV } from "../helpers/common";
import { isNumber } from "../helpers/core";
import { timeSeriesColunmTitle } from "./explore-plot";

interface DownloadDataButtonProps {
  data: (number | string | null)[] | {[key: string]: string | number}[]
  dataTimeline?: Date[] | null 
  model?: string
  coords?: [number, number] | null
  title?: string
  columnKey?: string
  lat?: number | string
  lon?: number | string
  filename?: string
}

export const DownloadDataButton = ({
  data, 
  dataTimeline,
  model, 
  coords, 
  title,
  columnKey,
  lat,
  lon,
  filename = '',
}: DownloadDataButtonProps) => {

  const useData: any[] = useMemo(() => {
    if (dataTimeline && columnKey && Array.isArray(data) && dataTimeline.length === data.length && data.length > 0) { 
      const d = data.map((row, index) => {
        const useDate = format(dataTimeline[index], 'dd/MM/yyyy HH:mm:ss');
        return {
          [columnKey]: row,
          [timeSeriesColunmTitle]: useDate
        }
      });
      // Add units column
      return [...d]
    }
    return [...data]
  }, [data, dataTimeline, columnKey])

  const useName = useMemo(() => {
    if (model) {
      if (coords) {
        return `-${model}-lat${coords[0]}-lon${coords[1]}`
      } else if (isNumber(lat) && isNumber(lon)) {
        return `-${model}-lat${lat}-lon${lon}`
      }
    }
    return filename
  }, [coords, lat, lon, model])

  if (title) {
    return (
      <Button
        title={title}
        startIcon={<DownloadIcon />}
        sx={{
          mt: 0,
          mb: "16px"
        }}
        onClick={() => {
          downloadDataAsCSV(useData, useName)
        } }
      >
        {title}
      </Button>
    )
  }


  return (
    <IconButton
      title="Download data as CSV"
      onClick={() => {
        downloadDataAsCSV(useData, useName)
      } }
    >
      <DownloadIcon />
    </IconButton>
  )
}
